import { ModalBase } from "../../../../components/Modals/ModalBase";
import BasicCardDocumentos from "../BasicCardDocumentos";
import InputForm from "../InputFormV2";
import DolarIcon from '../../../../media/felsv/Dollar.svg'
import { useSelector } from "react-redux";
import { State } from "../../../../reducers";
import useComprobanteLiquidacion from "../../../../actions/comprobante-liquidacion";

export default function ModalAgregarDocumentoFisico ({agregar} : {agregar?: boolean}) {
    const {onChangeFormDocumentoFisico, modal_cerrarDocumentoFisico, modal_button_agregarDocumentoFisico} = useComprobanteLiquidacion()
    const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
    const {formDocumentoFisico, errorsDocumentoFisico} = useSelector((state: State) => state.comprobanteLiquidacion)
    const optionsDTE = tipoDocumentosEmision.filter((doc: any) => doc.codigodocumento === '01' || doc.codigodocumento === '03' || doc.codigodocumento === '11' || doc.codigodocumento === '05' || doc.codigodocumento === '06')

    const handleChange = (e: any) => {
        onChangeFormDocumentoFisico(e.target.name, e.target.value)
    }

    return(
        <ModalBase>
            <BasicCardDocumentos title= {`${agregar ? 'Agregar' : 'Editar'} documento físico`}>  
                <div className='w-layout-hflex h-inputs'>
                    <InputForm error = {errorsDocumentoFisico?.tipoDTE} value = {formDocumentoFisico?.tipoDTE} onChange = {(e: any) => onChangeFormDocumentoFisico('tipoDTE', e.value)} required type = 'select' options = {optionsDTE} keyNameText = 'nombre' keyNameValue = 'codigodocumento' label = 'Tipo de DTE'/>
                    <InputForm maxLength = {20} error = {errorsDocumentoFisico?.noDocumento} name = 'noDocumento' value = {formDocumentoFisico?.noDocumento} onChange = {handleChange} required label = 'Número de documento'/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm error = {errorsDocumentoFisico?.fechaEmision} name = 'fechaEmision' value = {formDocumentoFisico?.fechaEmision} onChange = {handleChange} required label = 'Fecha de emisión' type = 'date'/>
                    <InputForm maxLength = {10} error = {errorsDocumentoFisico?.gravadas} name = 'gravadas' value = {formDocumentoFisico?.gravadas} onChange = {handleChange} label = {formDocumentoFisico?.tipoDTE === '11' ? 'Exportaciones' : 'Gravadas'} leftIcon = {DolarIcon}/>
                </div>
                    {formDocumentoFisico?.tipoDTE !== '11' &&
                    <>
                    <div className='w-layout-hflex h-inputs'>
                    <InputForm maxLength = {10} error = {errorsDocumentoFisico?.noSujeto} name = 'noSujeto' value = {formDocumentoFisico?.noSujeto} onChange = {handleChange} label = 'No sujeto' leftIcon = {DolarIcon}/>
                    <InputForm maxLength = {10} error = {errorsDocumentoFisico?.exentas} name = 'exentas' value = {formDocumentoFisico?.exentas} onChange = {handleChange} label = 'Exentas' leftIcon = {DolarIcon}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                    <div className='label-input'>
                    <InputForm maxLength = {10} error = {errorsDocumentoFisico?.montoIVA} name = 'montoIVA' value = {formDocumentoFisico?.montoIVA} onChange = {handleChange} label = 'Monto IVA' leftIcon = {DolarIcon}/>
                    </div><div className='label-input'></div>
                    </div>
                    </>
                    }
                <div style={{display: 'flex', gap: '20px'}}>
                    <button onClick={modal_cerrarDocumentoFisico} className="button transparent">Cancelar</button>
                    <button onClick={modal_button_agregarDocumentoFisico} className="button">{agregar ? 'Agregar' : 'Guardar'}</button>
                </div>
            </BasicCardDocumentos>
        </ModalBase>
    )
}